import { useShallow } from "zustand/react/shallow";

import KeyboardHint from "ds/components/KeyboardHint";
import ModalFooter from "ds/components/Modal/Footer";
import useCommandPaletteStore from "components/CommandPalette/store/useCommandPaletteStore";
import FeedbackButton from "components/FeedbackButton";
import Box from "ds/components/Box";
import BadgeNext from "ds/components/BadgeNext";

const CommandPaletteFooter = () => {
  const { currentView, setModalOpen } = useCommandPaletteStore(
    useShallow((state) => ({ currentView: state.currentView, setModalOpen: state.setModalOpen }))
  );

  const escLabel = currentView === "main" ? "Close" : "Go Back";

  return (
    <ModalFooter justify="between">
      <Box gap="large">
        <KeyboardHint keys="↑↓" label="Navigate" />
        <KeyboardHint keys="↵" label="Select" />
        <KeyboardHint keys="ESC" label={escLabel} />
      </Box>

      <Box gap="medium" align="center">
        <BadgeNext type="strong" variant="blue" text="BETA" />
        <FeedbackButton
          id="command-palette-feedback-button"
          variant="ghost"
          size="small"
          onPress={() => {
            setModalOpen(false);
          }}
        />
      </Box>
    </ModalFooter>
  );
};

export default CommandPaletteFooter;
